import Config from '@config';
import { initializeMeteringSealApi } from '@gasbi/shared/common/features/meteringSeal';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  meteringSealApi,
  useGetMeteringSealQuery,
  useGetMeteringSealByIdQuery,
  useCreateMeteringSealMutation,
  useDeleteMeteringSealByIdMutation,
  useGetMeteringSealInfiniteQuery,
  getCachedMeteringSealByIdSelector,
  useGetCachedMeteringSealByIdSelector,
} = initializeMeteringSealApi(Config.VITE_API_URL, axiosBaseQuery);
